import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { refreshBills } from "../../hooks/useBills";

interface Options {
  viewMode: "tables" | "products";
  /** Менюто още се зарежда — `Ordering` показва скелетона вместо масите. */
  menuLoading: boolean;
}

/**
 * Опресняванията на сметките в `Ordering`, които не са по клик/мутация
 * (docs/ordering.md). Заявка в полет се ползва (refreshBills), не тръгва втора.
 */
export function useOrderingBillsRefresh({ viewMode, menuLoading }: Options) {
  const queryClient = useQueryClient();

  // При връщане към масите („Назад", след „Поръчай") — промените на другите
  // сервитьори. Влизането в продуктите („Добави", нова маса, „Настани") НЕ тегли.
  useEffect(() => {
    // refreshBills: след „Поръчай" мутацията вече тегли — ползва се нейната заявка
    if (viewMode === "tables") void refreshBills(queryClient);
  }, [viewMode, queryClient]);

  // Масите се показват чак когато менюто дойде: тогава — свежи сметки към
  // момента на показването (при бавно меню първото четене е отпреди скелетона;
  // авто-изборът `TablesAutoSelect` чака точно това четене). При бързо меню се
  // слива със заявката в полет. Само при прехода true→false.
  const wasMenuLoading = useRef(menuLoading);
  useEffect(() => {
    if (wasMenuLoading.current && !menuLoading) void refreshBills(queryClient);
    wasMenuLoading.current = menuLoading;
  }, [menuLoading, queryClient]);
}
